module.exports = __webpack_public_path__ + "assets/img/shenyang.083fcde2.png";